// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

import { version } from './version';

export const environment = {
  production: true,
  appVersionAddon: '',
  webappName: 'Portaal en Regiekamer Behandelaar',
  api_endpoint: 'https://api.portaalregiekamer.nl/',
  pusher: {
    broadcaster: 'pusher',
    key: 'be039c2dba254f18b5e2',
    cluster: 'eu',
    forceTLS: true,
  },
  pusher_beams_client_id: null,
  sentry: {
    dsn: 'https://1053763a6ff3cfe277176805986cd903@o4507735602298880.ingest.de.sentry.io/4511093779005520',
    environment: 'production',
    version: version
  },
};
